import { dayjs, formatDate, MONTH_YEAR } from '@koob/dates';
import AllotmentsEditorRoomSelectButton from './AllotmentsEditorRoomSelectButton';

export default function AllotmentsEditorHeader({
  currentMonth,
  daysInMonth,
  selectAll,
  deselectAll,
}) {
  return (
    <div className="bg-gray-50 py-3 px-4 text-gray-500 font-medium">
      <div className="flex space-x-3 items-center">
        <div className="w-52 flex justify-between items-center sticky left-0 pl-2 z-20 bg-gray-50">
          <div>{formatDate(dayjs().month(currentMonth), MONTH_YEAR)}</div>

          <AllotmentsEditorRoomSelectButton
            selectAll={selectAll}
            deselectAll={deselectAll}
          />
        </div>

        {[...Array(daysInMonth)].map((_, i) => (
          <div key={i} className="text-center w-12">
            {i + 1 < 10 && '0'}
            {i + 1}
          </div>
        ))}
      </div>
    </div>
  );
}
